import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { ReviewsStats } from '@gate31/feature/ReviewsStats/ReviewsStats';

export class ReviewsStatsDesk extends ReviewsStats {
    static cn = new BaseJs.BuildCn('ReviewsStatsDesk');
}
